import React, { ChangeEventHandler, ReactNode } from "react";
import './styles.less'
type Props = {
	className?: string;
	onChange?: ChangeEventHandler<HTMLInputElement>;
	name?: string;
	id?: string;
	value?: string;
	checked?: boolean;
	children?: ReactNode;
	defaultChecked?: boolean;
	hasError?: boolean
};

const CheckboxCustomInput = (props: Props) => {
	return (
		<div className={props.className}>
			<div className={`checkboxCustomContainer`}>
				<input
					type="checkbox"
					className="checkBoxCustomInput"
					onChange={props.onChange}
					name={props.name}
					id={props.id}
					value={props.value}
					defaultChecked={props.defaultChecked}
					checked={props.checked}
					required
				/>
				<label htmlFor={props.id}>{props.children}</label>
			</div>
			{props.hasError && <span className="error-message">Obligatorio aceptar términos y condiciones</span>}
		</div>
	);
};

export default CheckboxCustomInput;

